import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from '@artemis/integrations/contentful/utils';

const Status = styled.p`
  width: 100%;
  text-align: center;
  opacity: 100%;
`;

const StateContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0%;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.65);
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const MerchantStateOverlay = ({ label }) => {
  if (!label) return null;

  return (
    <StateContainer data-testid="merchant-state-overlay">
      <Status>
        <FormattedMessage entry={label} />
      </Status>
    </StateContainer>
  );
};

MerchantStateOverlay.propTypes = {
  label: PropTypes.string,
};

export default MerchantStateOverlay;
